export const FORM_FIELD_CHECKBOX = 'checkbox',
  FORM_FIELD_TEXT = 'text',
  FORM_FIELD_PASSWORD = 'password',
  FORM_FIELD_EMAIL = 'email',
  FORM_FIELD_PHONE = 'phone',
  FORM_FIELD_SELECT = 'select',
  FORM_FIELD_MULTI_SELECT = 'multi-select',
  FORM_FIELD_TEXTAREA = 'textarea',
  FORM_FIELD_PLAIN_TEXT = 'plain-text',
  FORM_FIELD_IMAGE = 'image',
  FORM_FIELD_IMAGES_SET = 'images-set';
